module.exports = __webpack_public_path__ + "img/back-top-icon.5dfc0eaa.png";